export default {
  get name(): string {
    return 'ExponentImagePicker';
  },
};
